module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/headers-styles/header-style4/header-style4.component.scss
// module id = ./src/app/features/headers-styles/header-style4/header-style4.component.scss
// module chunks = main